<template>
	<div class="card">
		<div class="card-body">
			<h5><i class="fas fa-users"></i> Reinicio contraseña</h5>
			<b-alert show variant="warning"
				>Recuerda que al reiniciar la contraseña el alumno perdera la
				anterior.</b-alert
			>
			<b-col>
				<b-form-group id="input-group-1" label="Nueva contraseña">
					<b-form-input
						type="text"
						:class="{
							'is-invalid': camposVacio.pass,
							disabled: jsonCoordinadora.edicionAlumno
								? false
								: true,
						}"
						v-on:keyup="camposValidacion('password')"
						v-model="passwordAlumno"
						placeholder="Ingrese la contraseña del alumno"
						:disabled="
							jsonCoordinadora.edicionAlumno ? false : true
						"
					></b-form-input>
					<span v-if="error.pass" style="color:red">{{
						error.pass[0]
					}}</span>
				</b-form-group>
			</b-col>

			<b-button
				block
				v-if="jsonCoordinadora.edicionAlumno"
				variant="primary"
				@click="updatePassword()"
				><b-spinner v-if="arrayButton[0].btnPassword" small>
				</b-spinner>
				{{ arrayButton[0].msgButtonPasword }}
			</b-button>
			<b-button block v-else>
				{{ arrayButton[0].msgButtonPasword }}
			</b-button>
		</div>
		<toastComponent ref="toastComponent"></toastComponent>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import toastComponent from "@/components/toastComponent";
export default {
	components: {
		toastComponent,
	},
	data() {
		return {
			arrayButton: [{ msgButtonPasword: "Aceptar", btnPassword: false }],
			error: {},
			passwordAlumno: "",
			camposVacio: {},
		};
	},
	computed: {
		...mapState("alumno", ["jsonAlumno"]),
		...mapState("alumno", ["jsonCoordinadora"]),
	},
	methods: {
		async updatePassword() {
			const form = {
				pass: this.passwordAlumno,
			};
			const { data } = await this.axios.put(
				"api/editPass/" + this.jsonAlumno.idAlumno,
				form
			);
			const { estado, errores, msg } = data;

			switch (estado) {
				case "camposVacios":
					this.error = errores;
					this.camposVacio = this.error;
					break;
				case "cambiosHechos":
					const arrayToast = {
						msg: msg,
						title: "Exito",
						variant: "success",
					};
					this.$refs.toastComponent.makeToast(arrayToast);
					break;
				default:
					break;
			}
		},
		camposValidacion(param) {
			if (param == "password") {
				this.camposVacio.pass = false;
			}
		},
	},
};
</script>
